import axios from "axios";

export const downloadFileFirebase = async (url: string, fileName: string) => {
  try {
    const response = await axios.get(url, {
      responseType: "blob",
    });

    const file = new File([response.data], fileName, {
      type: response.data.type,
    });

    return file;
  } catch (error: any) {
    console.error(
      "[downloadFileFirebase] Error al descargar:",
      error.message || error
    );
    return undefined;
  }
};
